export default __webpack_public_path__ + "static/media/entity.898d1cd7.png";